export default {
    path: '/post-a-job',
    name: 'public-job-posting',
    component: () => import('source/pages/posting/JobPostingForm.vue'),
    meta: {
        title: 'Job Posting - HQZen',
    },
};
